/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import Topbar from '../PulseSurvey/Topbar';
import { Api } from '../../api';
import Breadcrumb from '../../component/common/Breadcrumb';
import CommonSelect from '../../component/common/select/CommonSelect';
import InputWithLabel from '../../component/common/InputWithLabel';
import { featuresHealthVideosPageData as mainPageData } from '../../utils/pageContent';
import { STATUS } from '../../utils/constants';
import VideoIcon from '../../assets/images/dummy-video-icon.png';
import {
  errorToast,
  MaxCharlimit,
  MaxCharlimitLongText,
  MaxCharlimitShort,
  capitalizeFirstLetter,
  capitalizeWords
} from '../../utils/helper';
import Duration from '../../component/common/Duration';
import Loader from '../../component/common/Loader';
import TextareaWithLabel from '../../component/common/TextareaWithLabel';
import LazyLoadImageProp from '../../component/common/LazyLoadImage';
import Icons from '../../component/svgs/icons';
import {
  AddEditGuidanceAudienceValidation,
  AddEditGuidanceContentValidation,
  AddEditGuidanceDetailsValidation
} from '../../validation/AddEditGuidanceValidation';

const pages = [{ name: mainPageData.editHealthVideosPageData.pageTitle, href: '/health-videos' }];

const LoadVideo = ({ previewVideo, setMin, setSec }) => {
  const videoEl = useRef(null);

  const handleLoadedMetadata = () => {
    const video = videoEl.current;
    if (!video) return;
    let minutes = Math.floor(video.duration / 60);
    let extraSeconds = video.duration % 60;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let sec = parseInt(extraSeconds);
    sec = sec < 10 ? '0' + sec : sec;
    setMin(minutes);
    setSec(sec);
  };

  function changeSource(url) {
    const video = document.getElementById('video');
    video.src = url;
  }

  useEffect(() => {
    changeSource(previewVideo);
  }, [previewVideo]);

  return (
    <video
      id="video"
      ref={videoEl}
      onLoadedMetadata={handleLoadedMetadata}
      className="m-auto h-[298px] object-center"
      controls
    >
      <source className=" h-[300px]" src={previewVideo} />
    </video>
  );
};

LoadVideo.propTypes = {
  previewVideo: PropTypes.any,
  setSec: PropTypes.any,
  setMin: PropTypes.any
};

const EditHealthVideos = () => {
  let location = useLocation();
  let propsData = location?.state;
  const pageData = mainPageData.editHealthVideosPageData;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const guidanceFile = useRef(null);
  const pageType = searchParams.get('type');
  const pageName = searchParams.get('page');
  const searchId = searchParams.get('id');
  const [isView, setIsView] = useState(false);
  const [view, setView] = useState(false);
  const [selectedType, setSelectedType] = useState(() => {
    const match = pageData.pageTypes.find((type) => type.value === pageType);
    return match ? match.value : pageData.pageTypes[0].value;
  });
  const [error, setError] = useState({});
  const [categoriesList, setCategoriesList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedAudience, setSelectedAudience] = useState([]);
  const [selectVideoType, setSelectVideoType] = useState([]);
  const [expertsList, setExpertsList] = useState([]);
  const [expertsLists, setExpertsLists] = useState([]);
  const [selectedExpert, setSelectedExpert] = useState('');
  const [previewExpert, setPreviewExpert] = useState('');
  const [selectedGuidance, setSelectedGuidance] = useState('');
  const [previewGuidance, setPreviewGuidance] = useState('');
  const [selectedFile2, setSelectedFile2] = useState('');
  const [selected, setSelected] = useState({});
  const [loader, setLoader] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState();
  const [previewVideo, setPreviewVideo] = useState('');
  const [minutes, setMinutes] = useState('00');
  const [sec, setSec] = useState('00');
  const [detailsValid, setDetailsValid] = useState(false);
  const [contentValid, setContentValid] = useState(false);
  const [audienceValid, setAudienceValid] = useState(false);

  const [form, setForm] = useState({
    guidanceId: '',
    guidanceTitle: '',
    description: '',
    guidanceType: 1,
    guidanceBy: 1,
    status: 1,
    video_iframe: '',
    approvalStatus: '',
    expertName: '',
    comments: []
  });

  useEffect(() => {
    const match = pageData.pageTypes.find((type) => type.value === pageType);
    setSelectedType(match ? match.value : pageData.pageTypes[0].value);
  }, [pageType, pageData.pageTypes]);

  useEffect(() => {
    Api.getCategoriesById(19).then((res) => {
      setCategoriesList(
        res?.data?.data?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?.name
          };
        })
      );
    });

    Api.getPodExpertsName().then((res) => {
      const expertsData = res?.data?.data?.map((item) => {
        return {
          ...item,
          label: item?.name,
          value: item?.name
        };
      });

      if (!propsData?.id) {
        setLoader(false);
      }
      setExpertsList(expertsData);
      setExpertsLists(expertsData);
    });
  }, []);

  const handleChangeType = (val) => {
    setSelectedType(val);
  };

  const radioHandler = (e) => {
    let { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: parseInt(value)
    }));
  };

  const handleChange = (e) => {
    var { name, value } = e.target;
    let processedValue = value;

    // Auto-capitalize based on field type
    if (name === 'guidanceTitle') {
      processedValue = capitalizeWords(value);
    } else if (name === 'description') {
      processedValue = capitalizeFirstLetter(value);
    }

    if (name === 'guidanceTitle' && processedValue !== '') {
      processedValue = processedValue?.slice(0, MaxCharlimit);
    }
    if (name === 'description' && processedValue !== '') {
      processedValue = processedValue?.slice(0, MaxCharlimitLongText);
    }
    if (name === 'video_iframe' && processedValue !== '') {
      processedValue = processedValue?.slice(0, MaxCharlimitShort);
    }
    const updatedForm = { ...form, [name]: processedValue };
    var updatedError = { ...error, [name]: '' };

    if (name === 'video_iframe' && processedValue !== '') {
      updatedError.guidanceFile = '';
    }
    setError(updatedError);
    if (
      !(name === 'guidanceTitle' && processedValue.length > MaxCharlimit) &&
      !(name === 'description' && processedValue.length > MaxCharlimitLongText) &&
      !(name === 'video_iframe' && processedValue.length > MaxCharlimitShort)
    ) {
      setForm(updatedForm);
    }
  };

  const handleGuidanceImage = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedExpert(undefined);
      return;
    }
    if (e?.target?.files[0]?.size > 1048576) {
      errorToast(pageData.fileShouldBeLessThan1MB);
    } else {
      if (e?.target?.files[0]) {
        if (!e?.target?.files[0].name.match(/\.(jpg|jpeg|png|gif)$/i)) {
          errorToast(
            `${pageData.validImageErrorMessageBeforeFileName} ${e?.target?.files[0].name} ${pageData.validImageErrorMessageafterFileName}`
          );
        } else {
          setSelectedGuidance(e.target.files[0]);
          const objectUrl = URL.createObjectURL(e.target.files[0]);
          setPreviewGuidance(objectUrl);
          return () => URL.revokeObjectURL(objectUrl);
        }
      } else {
        setPreviewGuidance(undefined);
      }
    }
  };

  const onSelectVideo = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedVideo(undefined);
      return;
    }

    if (e.target.files[0]) {
      if (!e?.target?.files[0].name.match(/\.(avi|mp4|m4v|webm)$/i)) {
        errorToast(
          `${pageData.validVideoErrorMessageBeforeFileName} ${e?.target?.files[0].name} ${pageData.validVideoErrorMessageafterFileName}`
        );
      } else if (e?.target?.files[0]?.size > 524288000) {
        errorToast(pageData.fileShouldBeLessThan500MB);
      } else {
        setSelectedVideo(e.target.files[0]);
        setSelectedFile2(e.target.files[0]);
        const objectUrl = URL.createObjectURL(e.target.files[0]);
        setPreviewVideo(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
      }
    } else {
      setPreviewVideo(undefined);
    }
  };

  const handleDetailsSubmit = () => {

    const { isValid, errors } = AddEditGuidanceDetailsValidation(
      form,
      selectedCategory,
      selected,
      false
    );
    if (errors) {
      setError(errors);
    }
    if (isValid === true) {
      setError(errors);
      setSelectedType(pageData.pageTypes[1].value);
      setDetailsValid(true);
    }

  };

  const handleContentSubmit = () => {
    const { isValid, errors } = AddEditGuidanceContentValidation(
      form,
      selectedGuidance,
      selectVideoType,
      selectedFile2,
      false
    );
    if (errors) {
      setError(errors);
    }
    if (isValid === true) {
      setError(errors);
      setSelectedType(pageData.pageTypes[2].value);
      setContentValid(true);
    }

  };

  const handleAudienceSubmit = () => {

    const { isValid, errors } = AddEditGuidanceAudienceValidation(
      form,
      selectedCategory,
      selectVideoType,
      selectedFile2,
      selectedGuidance,
      selected,
      selectedAudience,
      false
    );

    if (errors) {
      setError(errors);
    }
    if (isValid === true) {
      setError(errors);
      setAudienceValid(true);
    }
  };

  return (
    <div className="relative lg:mb-[45px]">
      {loader && <Loader />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageData.addMetaTitle}</title>
      </Helmet>
      <Topbar title={pageData.addPageTitle} />
      <Breadcrumb pageList={pages} className="lg:mt-8" />

      <div className="sm:flex flex-col md:flex-row mt-5 justify-between nd items-center gap-3">
        <div className="flex items-center h-full md:text-xl font-medium gap-6 text-shoorah-gray9 ">
          <button
            className={
              selectedType === pageData.pageTypes[0].value ? 'text-black dark:text-white' : ''
            }
            onClick={() => {
              handleChangeType(pageData.pageTypes[0].value);
            }}
          >
            {pageData.pageTypes[0].name}
          </button>
          <button
            className={
              selectedType === pageData.pageTypes[1].value ? 'text-black dark:text-white' : ''
            }
            disabled={!detailsValid}
            onClick={() => {
              handleChangeType(pageData.pageTypes[1].value);
            }}
          >
            {pageData.pageTypes[1].name}
          </button>
          <button
            className={
              selectedType === pageData.pageTypes[2].value ? 'text-black dark:text-white' : ''
            }
            disabled={!detailsValid || !contentValid}
            onClick={() => {
              handleChangeType(pageData.pageTypes[2].value);
            }}
          >
            {pageData.pageTypes[2].name}
          </button>
        </div>
      </div>

      {selectedType === pageData.pageTypes[0].value && (
        <div className="bg-white dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg border-[1.5px] border-shoorah-borderGray dark:border-transparent lg:rounded-2xl rounded-xl md:px-6 lg:py-10 md:py-6 p-4 lg:mt-10 w-full">
          <div className="grid lg:gap-5 gap-4 2xl:gap-10 md:grid-cols-2 2xl:grid-cols-2 grid-cols-1">
            <div className="lg:space-y-6 space-y-4 w-full">
              <InputWithLabel
                label={pageData.nameLabel}
                placeholder={pageData.namePlaceholder}
                onChange={handleChange}
                errorMargin="mt-1"
                labelMargin="mb-1"
                errorSize="text-[12px]"
                labelClassName="text-sm text-gray-700 dark:text-shoorah-darkBg"
                value={form.guidanceTitle}
                isLengthValidate={true}
                limit={MaxCharlimit}
                name={'guidanceTitle'}
                id={'guidanceTitle'}
                error={error?.guidanceTitle}
                isRequired={true}
                disabled={isView || view}
              />

              <TextareaWithLabel
                label={pageData.descriptionLabel}
                placeholder={pageData.descriptionPlaceholder}
                onChange={handleChange}
                errorMargin="mt-1"
                labelMargin="mb-1"
                errorSize="text-[12px]"
                className="min-h-[124px]"
                labelClassName="text-sm text-gray-700 dark:text-shoorah-darkBg"
                value={form.description}
                isLengthValidate={true}
                limit={MaxCharlimitLongText}
                name={'description'}
                id={'description'}
                error={error?.description}
                isRequired={true}
                disabled={isView || view}
              />

              <div className={`${isView ? 'cursor-default' : 'cursor-pointer'}`}>
                <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                  {pageData.statusLabel}
                </label>
                <fieldset className="mt-2">
                  <div className="flex space-x-4">
                    {STATUS.map((status, index) => (
                      <div key={index} className="flex items-center">
                        <input
                          id={status.name}
                          name="status"
                          type="radio"
                          value={status.value}
                          onChange={(e) => radioHandler(e)}
                          disabled={isView || view}
                          checked={status.value === form.status || form.status === 3}
                          className="h-5 w-5 border-gray-300 text-shoorah-primary focus:ring-shoorah-primary"
                        />
                        <label
                          htmlFor={status.name}
                          className="ml-3 block text-sm font-medium text-gray-700 dark:text-shoorah-darkBg"
                        >
                          {status.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="lg:space-y-6 space-y-4 w-full">
              <div>
                <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                  {pageData.selectCategoriesLabel}{' '}
                  {!isView && !view && <span className="text-red-400">&#42;</span>}
                </label>
                <CommonSelect
                  name="categories"
                  controlCustomStyle={{ padding: '1px' }}
                  isMulti={true}
                  onChange={(e) => {
                    setSelectedCategory(e);
                    setError((prev) => ({ ...prev, focus: '' }));
                  }}
                  value={selectedCategory}
                  options={categoriesList}
                  disabled={isView || view}
                />
                <span className="text-red-500 text-[12px] mt-1">{error.focus}</span>
              </div>
              <div className={`${isView ? 'cursor-default' : 'cursor-pointer'}`}>
                <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                  {pageData.selectExpertLabel}{' '}
                  {!isView && !view && <span className="text-red-400">&#42;</span>}
                </label>
                <CommonSelect
                  name="expert"
                  onChange={(e) => {
                    setSelected(e);
                    setError((prev) => ({ ...prev, expertId: '' }));
                  }}
                  value={expertsList?.find((option) => option?.value === selected?.value)}
                  options={expertsList}
                  disabled={isView || view}
                />
                <span className="text-red-500 text-[12px] mt-1">{error.expertId}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedType === pageData.pageTypes[1].value && (
        <div className="bg-white dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg border-[1.5px] border-shoorah-borderGray dark:border-transparent lg:rounded-2xl rounded-xl md:px-6 lg:py-10 md:py-6 p-4 lg:mt-10 w-full">
          <div className="grid gap-4  md:grid-cols-1 2xl:grid-cols-2 grid-cols-1">
            <div className="lg:space-y-6 space-y-4 w-full">
              {!isView && (
                <div className="mt-4">
                  <label
                    htmlFor="thumbnail_image_url "
                    className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm"
                  >
                    {pageData.thumbnailLabel}{' '}
                    {!selectedFile2 && !isView && !view && (
                      <span className="text-red-400">&#42;</span>
                    )}{' '}
                    {pageData.thumbnailSize}
                  </label>
                  <div className="mt-1">
                    {previewGuidance ? (
                      <>
                        <div className="relative">
                          <div
                            onClick={() => guidanceFile.current.click()}
                            className="h-10 flex items-center justify-between gap-3 w-full rounded-lg px-4 py-[8px] text-sm text-shoorah-lightBlack dark:border-shoorah-darkBorder dark:text-shoorah-darkBg appearance-none placeholder-gray-400 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-[1.5px] border-shoorah-borderGray"
                          >
                            <p className="truncate mr-6">
                              {selectedGuidance?.name
                                ? selectedGuidance?.name
                                : previewGuidance?.split('/')[
                                    previewGuidance?.split('/')?.length - 1
                                  ]}
                            </p>
                          </div>
                          <input
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            className="hidden"
                            ref={guidanceFile}
                            onChange={(e) => handleGuidanceImage(e)}
                          />

                          <XMarkIcon
                            className="absolute top-1/2 transform -translate-y-1/2 right-[10px] w-[20px] text-red-500 cursor-pointer"
                            onClick={() => {
                              setSelectedGuidance('');
                              setPreviewGuidance('');
                            }}
                          />
                        </div>
                        <div className="mx-auto border rounded-lg mt-2 text-center">
                          <LazyLoadImageProp
                            imageSrc={previewGuidance}
                            className="mx-auto max-h-[250px]"
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png"
                          className="hidden"
                          ref={guidanceFile}
                          onChange={(e) => handleGuidanceImage(e)}
                        />
                        <div
                          onClick={() => guidanceFile.current.click()}
                          className="flex justify-center items-center overflow-hidden rounded-[9px] border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder w-full h-[240px] bg-shoorah-normanGray dark:bg-shoorah-darkBgColor relative"
                        >
                          <div className="flex flex-col justify-center items-center">
                            <Icons.videoUploadIcon className="mb-5 text-shoorah-primary" />
                            <h5 className="text-xs">
                              {pageData.dropYourImageText}{' '}
                              <span className="text-shoorah-primary font-medium">
                                {pageData.browseText}
                              </span>
                            </h5>
                            <p className="text-shoorah-gray9 text-[8px] leading-[12px]">
                              {pageData.imageSupprotFileType}
                            </p>
                          </div>
                        </div>
                        <span className="text-red-500 text-[12px] mt-1">{error.guidanceImage}</span>
                      </>
                    )}
                  </div>
                </div>
              )}
              {(isView || view) && previewGuidance && (
                <div className="mt-4">
                  <label
                    htmlFor="thumbnail_image_url"
                    className="block text-sm font-medium text-gray-700 dark:text-shoorah-darkBg"
                  >
                    {pageData.thumbnailImageLabel}
                  </label>
                  <div className="mx-auto border rounded-lg mt-2 text-center">
                    <LazyLoadImageProp
                      imageSrc={previewGuidance}
                      className="mx-auto max-h-[250px]"
                    />
                  </div>
                </div>
              )}

              <div>
                <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                  {pageData.selectVideoTypeText}{' '}
                  {!isView && !view && <span className="text-red-400">&#42;</span>}
                </label>
                <CommonSelect
                  name="videoType"
                  controlCustomStyle={{ padding: '1px' }}
                  isMulti={false}
                  onChange={(e) => {
                    setSelectVideoType(e);
                    setError((prev) => ({ ...prev, videoType: '' }));
                  }}
                  value={selectVideoType}
                  options={pageData.videoTypeOptions}
                  disabled={isView || view}
                />
                <span className="text-red-500 text-[12px] mt-1">{error.videoType}</span>
              </div>

              {selectVideoType === pageData.videoTypeOptions[0] && !selectedFile2 && (
                <InputWithLabel
                  label={pageData.videoIDLabel}
                  placeholder={pageData.videoIDPlaceholder}
                  onChange={handleChange}
                  errorMargin="mt-1"
                  labelMargin="mb-1"
                  errorSize="text-[12px]"
                  labelClassName="text-sm text-gray-700 dark:text-shoorah-darkBg"
                  value={form.video_iframe}
                  name={'video_iframe'}
                  isLengthValidate={true}
                  limit={MaxCharlimitShort}
                  id={'video_iframe'}
                  error={error?.video_iframe}
                  isRequired={true}
                  disabled={isView || view}
                />
              )}

              {selectVideoType === pageData.videoTypeOptions[1] && (
                <>
                  <input
                    className="hidden"
                    ref={videoRef}
                    onInput={(event) => {
                      onSelectVideo(event);
                      event.target.value = null;
                    }}
                    type="file"
                    accept="video/mp4,video/x-m4v,video/*"
                  />
                  {selectedVideo || previewVideo ? (
                    <>
                      {previewVideo && (
                        <div
                          className="relative flex flex-col sm:flex-row md:flex-col lg:flex-row
 gap-6"
                        >
                          <div>
                            <p>{pageData.uploadVideoLabel}</p>
                            <div className="bg-gray-100 mt-4 cursor-pointer h-[300px] border rounded-xl overflow-hidden ">
                              <LoadVideo
                                previewVideo={previewVideo}
                                setMin={setMinutes}
                                setSec={setSec}
                              />
                            </div>
                          </div>
                          <div className="ml-4">
                            <p>{pageData.durationLabel}</p>
                            <Duration
                              min={minutes}
                              sec={sec}
                              setSec={setSec}
                              setMin={setMinutes}
                              disabled={true}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <p>{pageData.uploadVideoLabel}</p>
                      <div
                        onClick={() => {
                          videoRef?.current?.click();
                        }}
                        className="border-[3px] border-dashed border-gray-300 rounded-2xl mt-4 cursor-pointer h-[300px] flex justify-center items-center p-3  mx-auto text-center w-full bg-shoorah-normanGray"
                      >
                        <div>
                          <img
                            src={VideoIcon}
                            loading="lazy"
                            className="self-start mx-auto h-[70px] w-[80px]"
                            alt="ArrowUpRight"
                          />
                          <p className="text-sm mt-1 text-passio-grayText ">
                            <span className="text-shoorah-primary font-medium">
                              {pageData.clickHerText}
                            </span>{' '}
                            {pageData.uploadOrDropMediaText}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {selectedType === pageData.pageTypes[2].value && (
        <div className="bg-white dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg border-[1.5px] border-shoorah-borderGray dark:border-transparent lg:rounded-2xl rounded-xl md:px-6 lg:py-10 md:py-6 p-4 lg:mt-10 w-full">
          <p>{pageData.whereToShowVideoLabel}</p>
          <div className="grid mt-4 lg:gap-5 gap-4 2xl:gap-10 md:grid-cols-2 2xl:grid-cols-4 grid-cols-1">
            <div>
              <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                {pageData.selectAudienceText}{' '}
                {!isView && !view && <span className="text-red-400">&#42;</span>}
              </label>
              <CommonSelect
                name="audience"
                controlCustomStyle={{ padding: '1px' }}
                isMulti={false}
                onChange={(e) => {
                  setSelectedAudience(e);
                  setError((prev) => ({ ...prev, audience: '' }));
                }}
                value={selectedAudience}
                options={pageData.selectedAudienceOptions}
                disabled={isView || view}
              />
              <span className="text-red-500 text-[12px] mt-1">{error.audience}</span>
            </div>
          </div>
        </div>
      )}

      <div className="md:col-span-2 pt-4">
        <div className="lg:space-y-6 space-y-4 w-full flex justify-end">
          <div className="sm:text-right flex gap-x-4 sm:justify-end justify-start">
            {selectedType === pageData.pageTypes[0].value && (
              <button
                onClick={handleDetailsSubmit}
                className="btn-primary"
              >
                {pageData.continueBtnText}
                <ChevronRightIcon className="w-7 h-7" />
              </button>
            )}
            {selectedType === pageData.pageTypes[1].value && (
              <button
                onClick={handleContentSubmit}
                className="btn-primary"
              >
                {pageData.continueBtnText}
                <ChevronRightIcon className="w-7 h-7" />
              </button>
            )}
            {selectedType === pageData.pageTypes[2].value && (
              <>
                <button
                  className="btn-primary"
                >
                  {pageData.saveAsDraftBtnText}
                </button>
                <button
                  onClick={handleAudienceSubmit}
                 className="btn-primary"
                >
                  {pageData.submitBtnText}
                  <ChevronRightIcon className="w-7 h-7" />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditHealthVideos;
